<template>
  <div class="row finance-settigs">
    <div class="col">
      <div class="row">
        <div class="col mx-2">
          <form class="form-inline py-2 justify-content-start">
            <div class="d-flex align-items-center">
              <button type="button" class="btn btn-back btn-lg" @click="$router.push('/settings')">
                <i class="fa fa-angle-left px-1"></i>
              </button>
              <h2 class="ml-2">Настройки финансов</h2>
            </div>
          </form>
        </div>
      </div>
      <div class="row">
        <div class="col" v-if="isAddAccountActive">
          <form class="form-inline align-items-start justify-content-between">
            <div class="d-flex align-items-start">
              <input
                type="text"
                placeholder="Номер"
                v-model="accountForAdd.number"
                class="form-control mr-2"
              >
              <input
                type="text"
                placeholder="Название"
                v-model="accountForAdd.name"
                class="form-control mr-2"
              >
              <textarea
                class="form-control mr-2"
                rows="1"
                placeholder="Описание"
                v-model="accountForAdd.description"
              ></textarea>
              <div>
                <div class="finance-settigs__property-pill" v-if="accountForAdd.enabled">
                    <span>активный</span>
                </div>
                <span class="cursor-pointer" v-else @click="accountForAdd.enabled = true">активный</span>
                <div class="finance-settigs__property-pill finance-settigs__property-pill--disabled"  v-if="!accountForAdd.enabled">
                  <span>не активный</span>
                </div>
                <span class="cursor-pointer" v-else @click="accountForAdd.enabled = false">не активный</span>
              </div>
            </div>
            <div class="d-flex">
              <button
                type="button"
                class="btn btn-secondary"
                @click="closeAddAccount"
              >{{ $t('home.cancel') }}</button>
              <button
                type="button"
                class="btn btn-primary ml-2"
                @click="saveNewAccount"
              >{{ $t('home.add') }}</button>
            </div>
          </form>
        </div>
        <div class="col" v-else>
          <div class="d-flex align-items-center justify-content-end w-100">
            <button type="button" class="btn btn-outline-primary" @click="showAddAccount">
              <i class="ico ico-plus mr-2"></i>добавить счет</button>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="column">
          <table class="table px-3">
            <thead>
              <tr>
                <th v-for="item in tableHeaderItems" :key="item.name" :style="{'width': item.width * 100 / tableHeaderItems.map(x=>x.width).reduce((a, b) => a + b) + '%'}">
                  <div class="table-th">{{ item.viewName }}</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="account in accounts" :class="{'tr-edit-mode' : account.inEditing}" :key="account.id">
                <td v-if="!account.inEditing">
                  <div class="td-content" :title="account.number">{{account.number}}</div>
                </td>
                <td v-else>
                  <input type="text" class="form-control form-control-sm" v-model="account.number">
                </td>
                <td v-if="!account.inEditing">
                  <div class="td-content" :title="account.name">{{account.name}}</div>
                </td>
                <td v-else>
                  <input type="text" class="form-control form-control-sm" v-model="account.name">
                </td>
                <td v-if="!account.inEditing">
                  <div class="td-content td-content-lg" :title="account.description">{{account.description}}</div>
                </td>
                <td v-else>
                  <textarea type="text" rows="1" class="form-control form-control-sm" v-model="account.description"></textarea>
                </td>
                <td v-if="!account.inEditing">
                  <div class="td-content td-content-lg" :title="account.enabled ? 'активный': 'не активный'">
                    <div class="finance-settigs__property-pill" v-if="account.enabled">
                      <span>активный</span>
                    </div>
                    <div class="finance-settigs__property-pill finance-settigs__property-pill--disabled"  v-if="!account.enabled">
                      <span>не активный</span>
                    </div>
                  </div>
                </td>
                <td v-else>
                  <div class="finance-settigs__property-pill" v-if="account.enabled">
                      <span>активный</span>
                  </div>
                  <span class="cursor-pointer" v-else @click="account.enabled = true">активный</span>
                  <div class="finance-settigs__property-pill finance-settigs__property-pill--disabled"  v-if="!account.enabled">
                    <span>не активный</span>
                  </div>
                  <span class="cursor-pointer" v-else @click="account.enabled = false">не активный</span>
                </td>
                <td>
                  <div class="td-content" :title="account.balance">{{account.balance}}</div>
                </td>
                <td align="center" v-if="!account.inEditing">
                  <button type="button" class="btn btn-sm btn-primary  px-3" @click="editAccount(account)" v-show="!account.inEditing">
                    <i class="fa fa-pencil"></i>
                  </button>
                </td>
                <td align="center" v-else>
                  <button type="button" class="btn btn-sm btn-secondary px-3" @click="cancelEditing(account)" v-show="account.inEditing">
                    <i class="fa fa-times"></i>
                  </button>
                  <button type="button" class="btn btn-sm btn-primary px-3" @click="saveEditedAccount(account)" v-show="account.inEditing">
                    <i class="fa fa-check"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../api'
import { sortBy } from 'lodash'

const getNewAccount = () => {
  return {
    name: '',
    number: '',
    description: '',
    enabled: true
  }
}

const formatNumber = (num) => {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
}

export default {
  name: 'FinanceSettigs',
  data () {
    return {
      accounts: [],
      accountBackups: [],
      accountForAdd: {},
      isAddAccountActive: false,
      tableHeaderItems: this.getTableHeader()
    }
  },
  methods: {
    getTableHeader () {
      return [
        {
          name: 'number',
          viewName: 'Номер',
          width: 150,
          isVisible: true
        },
        {
          name: 'name',
          viewName: 'Название',
          width: 175,
          isVisible: true
        },
        {
          name: 'description',
          viewName: this.$t('home.description'),
          width: 200,
          isVisible: true
        },
        {
          name: 'enabled',
          viewName: 'Статус',
          width: 200,
          isVisible: true
        },
        {
          name: 'balance',
          viewName: 'Баланс',
          width: 175,
          isVisible: true
        },
        {
          name: 'actions',
          viewName: '',
          width: 125,
          isVisible: this.isUserCanEditaccounts
        }
      ]
    },
    showAddAccount () {
      this.accountForAdd = getNewAccount()
      this.isAddAccountActive = true
    },
    closeAddAccount () {
      this.isAddAccountActive = false
    },
    saveNewAccount () {
      api.post.addFinanceAccount(this.accountForAdd)
        .then(() => {
          this.closeAddAccount()
          this.loadAccounts()
        })
        .catch(() => {
          this.$notify({
            message: 'Произошла ошибка',
            type: 'danger'
          })
        })
    },
    editAccount (account) {
      const accountIndex = this.accounts.findIndex(x => x.id === account.id)
      this.accountBackups[accountIndex] = Object.assign({}, account)
      account.inEditing = true
      this.accounts.splice(accountIndex, 1, account)
    },
    cancelEditing (account) {
      const accountIndex = this.accounts.findIndex(x => x.id === account.id)
      this.accounts.splice(accountIndex, 1, this.accountBackups[accountIndex])
      this.accountBackups[accountIndex] = null
    },
    saveEditedAccount (account) {
      api.post.updateFinanceAccount(account.id, account)
        .then(() => {
          const accountIndex = this.accounts.findIndex(x => x.id === account.id)
          account.inEditing = false
          this.accounts.splice(accountIndex, 1, account)
          this.accountBackups[accountIndex] = null
        })
        .catch(() => {
          this.$notify({
            message: 'Произошла ошибка',
            type: 'danger'
          })
        })
    },
    loadAccounts () {
      api.get.financeAccounts()
        .then((resp) => {
          this.accounts = sortBy(resp.data.data.finance_accounts.map(x => { return { ...x, inEditing: false, balance: formatNumber(+x.balance) } }), 'name')
        })
        .catch(() => {
          this.$notify({
            message: 'Произошла ошибка',
            type: 'danger'
          })
        })
    }
  },
  created () {
    this.loadAccounts()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$eventBus.$emit('pageHeaderChange', 'настройки финансов')
    })
  }
}
</script>

<style lang="scss">
.finance-settigs {
  &__property-pill {
    display: inline-block;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    text-align: center;
    width: 84px;
    height: 17px;
    color: #fff;
    background-color: #28bd8b;
    border-radius: 4px;

    &--disabled {
      background-color: #f34d65;
    }
  }
}
</style>
